var _g, _path, _path2, _path3, _path4, _path5, _line, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGluten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gluten",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.204
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#c7a662"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14666",
    "data-name": "Path 14666",
    d: "M320.3,749.116s-2.855,4.357,3.441,10.448l3.669-5.6s1.2-1.841.224-5.1a13.3,13.3,0,0,0-3.668-5.35Z",
    transform: "translate(-259.95 -692.816)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14668",
    "data-name": "Path 14668",
    d: "M324.044,749l-5.855,3.248c5.619,6.725,10.173,4.2,10.173,4.2l5.855-3.248c-5.619-6.724-10.173-4.2-10.173-4.2",
    transform: "translate(-264.258 -678.084)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14670",
    "data-name": "Path 14670",
    d: "M322.132,750.995s-2.851,4.357,3.445,10.448l3.669-5.6s2.851-4.357-3.445-10.448Z",
    transform: "translate(-254.584 -687.295)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14672",
    "data-name": "Path 14672",
    d: "M325.222,750.549l-4.746,2.635c4.558,5.454,8.25,3.405,8.25,3.405l4.746-2.635c-4.557-5.454-8.25-3.405-8.25-3.405",
    transform: "translate(-257.552 -673.287)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14674",
    "data-name": "Path 14674",
    d: "M323.507,752.322s-2.312,3.535,2.792,8.478l2.977-4.542s2.312-3.535-2.8-8.478Z",
    transform: "translate(-250.198 -680.301)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x1: 35,
    y1: 39,
    transform: "translate(40.478 41.363)",
    fill: "#fcf6ea",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17546",
    "data-name": "Path 17546",
    d: "M320.3,749.116s-2.855,4.357,3.441,10.448l3.669-5.6s1.2-1.841.224-5.1a13.3,13.3,0,0,0-3.668-5.35Z",
    transform: "translate(-266.076 -700.842)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17547",
    "data-name": "Path 17547",
    d: "M320.3,749.116s-2.855,4.357,3.441,10.448l3.669-5.6s1.2-1.841.224-5.1a13.3,13.3,0,0,0-3.668-5.35Z",
    transform: "translate(-273.076 -707.842)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17548",
    "data-name": "Path 17548",
    d: "M320.3,749.116s-2.855,4.357,3.441,10.448l3.669-5.6s1.2-1.841.224-5.1a13.3,13.3,0,0,0-3.668-5.35Z",
    transform: "translate(-280.076 -713.893)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17549",
    "data-name": "Path 17549",
    d: "M324.044,749l-5.855,3.248c5.619,6.725,10.173,4.2,10.173,4.2l5.855-3.248c-5.619-6.724-10.173-4.2-10.173-4.2",
    transform: "translate(-272.272 -685.244)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17550",
    "data-name": "Path 17550",
    d: "M324.044,749l-5.855,3.248c5.619,6.725,10.173,4.2,10.173,4.2l5.855-3.248c-5.619-6.724-10.173-4.2-10.173-4.2",
    transform: "translate(-278.258 -693.619)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17551",
    "data-name": "Path 17551",
    d: "M324.044,749l-5.855,3.248c5.619,6.725,10.173,4.2,10.173,4.2l5.855-3.248c-5.619-6.724-10.173-4.2-10.173-4.2",
    transform: "translate(-286.272 -701.001)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17552",
    "data-name": "Path 17552",
    d: "M324.044,749l-5.855,3.248c5.619,6.725,10.173,4.2,10.173,4.2l5.855-3.248c-5.619-6.724-10.173-4.2-10.173-4.2",
    transform: "translate(-290.454 -709.377)",
    fill: "#c7a662",
    stroke: "#a28751",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluten);
export default __webpack_public_path__ + "static/media/Gluten.8d82d88d4487837b2e2b79fec21b0da9.svg";
export { ForwardRef as ReactComponent };